'use client';
import ChevronRight from '@/assets/svgs/chevron-right-small.svg';
import { inter500, inter600 } from '@/config/fonts';
import { useFetchAccountStatus } from '@/containers/Accounts/api';
import { parseAccountStatusValue } from '@/containers/Accounts/types';
import { selectPrimaryRootAccount } from '@/lib/redux/app.selectors';
import IconButton from '@/shared/components/Buttons/IconButton/IconButton';
import NumberCountdown from '@/shared/components/NumberCountdown/NumberCountdown';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

interface BalanceProps {
  className?: string;
}

const Balance = ({ className }: BalanceProps) => {
  const [amount, setAmount] = useState<number>();
  const rootAccount = useSelector(selectPrimaryRootAccount);
  const { isLoading, data, error } = useFetchAccountStatus(rootAccount, !!rootAccount);

  useEffect(() => {
    if (data && !isLoading) {
      const balance = parseAccountStatusValue(data.data?.balance);
      if (typeof balance !== 'undefined') {
        setAmount(balance);
      }
    }
  }, [data, isLoading]);

  return (
    <div
      className={classNames(
        'remaining-balance bg-base-200 h-16 rounded-xl px-4 py-2',
        className
      )}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className={classNames(inter500.className, 'text-gray-default text-sm')}>
            Remaining Balance
          </div>
          <div className={classNames(inter600.className, 'text-black-600 text-lg')}>
            {(isLoading || !data) && !error && (
              <span className="loading loading-spinner loading-sm text-gray-600"></span>
            )}
            {error && <span className="text-[12px]">N/A</span>}
            {!isLoading && typeof amount !== 'undefined' && (
              <NumberCountdown
                endNumber={amount}
                duration={300}
                useCsvNumbers
                prefix="$"
              />
            )}
          </div>
        </div>
        <IconButton icon={<ChevronRight />} />
      </div>
    </div>
  );
};

export default Balance;
